import * as React from 'react'
import ConfirmationDialog, {
  DialogCustomization,
} from '../components/ConfirmationDialog'

// TODO: Extract Option type outside dynamic-form and rename to SelectOption or something
import { Option } from '../interfaces/components/dynamic-form'
import ConfirmationDialogWithOptions from './ConfirmationDialogWithOptions'

interface CallToActionProps {
  children: React.ReactNode
  disabled?: boolean
  confirm: boolean
  onClick: (option?: string) => any

  className?: string

  dialog?: DialogCustomization & { options?: Option[] }
}
interface CallToActionState {
  dialogShown: boolean
}

function CallToAction(props: CallToActionProps) {
  const [state, setState] = React.useState<CallToActionState>({
    dialogShown: false,
  })

  React.useEffect(() => {
    setState({ dialogShown: false })
  }, [props.confirm])

  const handleClick = () => {
    if (props.disabled === true) {
      return false
    }
    if (props.confirm) {
      setState({
        dialogShown: true,
      })
    } else {
      props.onClick()
    }
  }

  const closeDialog = () => {
    setState({
      dialogShown: false,
    })
  }

  const handleConfirmWithOption = (option: string) => {
    setState({
      dialogShown: false,
    })
    props.onClick(option)
  }

  const handleConfirm = () => {
    setState({
      dialogShown: false,
    })
    props.onClick()
  }

  const dialogProps = props.dialog || {}

  return (
    <div className={'cp-cta' + (props.className ? ` ${props.className}` : '')}>
      <span onClick={handleClick}>{props.children}</span>

      {dialogProps.options !== undefined ? (
        <ConfirmationDialogWithOptions
          open={state.dialogShown}
          onClose={closeDialog}
          onConfirm={handleConfirmWithOption}
          options={dialogProps.options}
          {...dialogProps}
        />
      ) : (
        <ConfirmationDialog
          open={state.dialogShown}
          onClose={closeDialog}
          onConfirm={handleConfirm}
          {...dialogProps}
        />
      )}
    </div>
  )
}

export default CallToAction
